module.exports = __webpack_public_path__ + "static/img/中奖啦.3537cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/live/中奖啦.png
// module id = f+HZ
// module chunks = 1